import styled from 'styled-components';

export const HomeContainer = styled.div`
  padding-bottom: 90px;
`;
